import React, {useEffect, useRef, useState} from 'react';
import './PopupInfoMulti.css';
import DetailInfo from './DetailInfo';


const PopupInfoMulti = ({ infoArray, closePopup, loadDetail, sceneFilter }) => {
    const refDetailInfo = useRef(null);
    const [itemInfoIndex, setItemInfoIndex] = useState(0);
    const [showDetailInfo, setShowDetailInfo] = useState(false);
    const [isVisArr, setIsVisArr] = useState([true, true, true, true, true, true]);
    function toggleDetailInfo () {
        //console.log('WANT MORE INFO', infoArray);
        setShowDetailInfo(!showDetailInfo);
    }

    useEffect(() => {
        //console.log("PROJECT DATA CHANGED");
        //console.log('applySceneFilter: ', applySceneFilter);
        //console.log('projectData: ', projectData);
        //console.log('sceneFilter: ', sceneFilter);
        if (sceneFilter !== null) {
            ApplySceneFilter();
            //console.log('RAN SCENE FILTER UPDATE ON THREEANIM.JS');
        }


    }, [sceneFilter]);
    //Filter
    function ApplySceneFilter () {
        //console.log("xxxxxxxxxx", projectData);
        //while(overlayItemsReady === false) {
        //console.log('setting up scene...');
        //}
        //console.log("FILTERS:", sceneFilter);
        let newVisArr = [];
        for(let i = 0; i < infoArray.length; i++) {
            const unit = infoArray[i];

            let visState = true;

            //CHeck Type
            //console.log(unit.name, unit.type, unit.status);
            if(sceneFilter.types.includes(unit.type.toLowerCase())) {

            } else {
                visState = false;
            }

            //Check Features
            if(sceneFilter.waterFront) {
                if(unit.waterFront === "no") {
                    visState = false;
                }
            }
            if(sceneFilter.oceanView) {
                if(unit.oceanView === "no") {
                    visState = false;
                }
            }
            if(sceneFilter.bayView) {
                if(unit.bayView === "no") {
                    visState = false;
                }
            }

            //Check price renage
            if(unit.totalPrice < sceneFilter.minPrice || unit.totalPrice > sceneFilter.maxPrice) {
                visState = false;
            }

            //Cheeck sale status
            if(sceneFilter.status.includes(unit.status.toLowerCase())) {

            } else {
                visState = false;
            }


            newVisArr.push(visState)
        }
        setIsVisArr(newVisArr);
    }


    //console.log('LOADING POPUPINFO ARRAY', infoArray);
    return (
        <div>
            {showDetailInfo && (
                <DetailInfo
                    ref={refDetailInfo}
                    isVisible={showDetailInfo}
                    toggleComponent={toggleDetailInfo}
                    itemInfo={infoArray[itemInfoIndex]}
                />
            )}

                <div className="popup-frame">
                    <div className="popup-image" onClick={() => loadDetail}>
                        <div className="popup-close" onClick={closePopup}>X</div>
                        <img src={infoArray[itemInfoIndex].media[0]} alt={`Image ${0}`} />
                    </div>
                    <h3 className="popup-content-multi-h3" >Villas</h3>

                    {infoArray.map((item, index) => {
                        //console.log(infoArray[index].name); // Log the name for each item

                        return (
                            <div className="popup-content-multi" key={index}>
                                <button
                                    className="popup-content-multi"
                                    onClick={() => {
                                        if (isVisArr[index]) { // Only allow click if isVisArr[index] is true
                                            setItemInfoIndex(index);
                                            toggleDetailInfo();
                                        }
                                    }}
                                    disabled={!isVisArr[index]} // Disable the button if isVisArr[index] is false
                                    style={{
                                        cursor: isVisArr[index] ? 'pointer' : 'not-allowed', // Change cursor for better UX
                                        opacity: isVisArr[index] ? 0.97 : 0.5 // Adjust opacity for a "disabled" look
                                    }}
                                >
                                    {item.displayName}
                                </button>
                            </div>
                        );
                    })}



                </div>
        </div>
    );

};

export default PopupInfoMulti;
